import { render, staticRenderFns } from "./OptometristPrescriptionsAdd.vue?vue&type=template&id=bf857d00&"
import script from "./OptometristPrescriptionsAdd.vue?vue&type=script&lang=js&"
export * from "./OptometristPrescriptionsAdd.vue?vue&type=script&lang=js&"
import style0 from "./OptometristPrescriptionsAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports